import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import userService from '../services/userService'

export const useUserStore = defineStore('user', () => {
  const user = ref({})
  const tips = ref({})

  const checkUser = async () => {
    try {
      await userService.check()
      return true
    } catch {
      return false
    }
  }

  const loadUser = async () => {
    try {
      const result = await userService.load()
      user.value = result.user
    } catch (error) {
      console.error('Error while fetching user:', error)
    }

    try {
      const result = await userService.loadTips()
      tips.value = result.tips
    } catch (error) {
      console.error('Error while fetching tips:', error)
    }
  }

  function userStatesFor(xard) {
    let states = []
    // TODO: has date
    // if (nowXardIds.value.has(xard.id)) {
    //   states.push("calendar")
    // }
    if (topXardIds.value.has(xard.id)) {
      states.push('top')
    }
    if (flopXardIds.value.has(xard.id)) {
      states.push('flop')
    }
    if (checkinXardIds.value.has(xard.id)) {
      states.push('checkin')
    }
    if (nowXardIds.value.has(xard.id)) {
      states.push('now')
    }
    if (xard.isNew) {
      states.push('new')
    }
    const isTwinTip = twinTipXardIds.value.has(xard.id)
    if (isTwinTip) {
      states.push('twin')
    }
    if (xard.isTrend) {
      states.push('trend')
    }
    if (!isTwinTip && xard.isTip) {
      states.push('tip')
    }
    if (xard.isFlopTrend) {
      states.push('flop-trend')
    }

    return states
  }

  const flopXardIds = computed(() => {
    return new Set(user.value?.flopXardIds || [])
  })
  const topXardIds = computed(() => {
    return new Set(user.value?.topXardIds || [])
  })
  const checkinXardIds = computed(() => {
    return new Set(user.value?.checkinXardIds || [])
  })
  const listXardIds = computed(() => {
    return new Set(user.value?.listXardIds || [])
  })
  const nowXardIds = computed(() => {
    return new Set(user.value?.nowXardIds || [])
  })
  const twinTipXardIds = computed(() => {
    return new Set(tips.value?.promotedTipItemIds || [])
  })
  const newTipXardIds = computed(() => {
    return new Set(tips.value?.newTipItemIds || [])
  })

  return {
    user,
    flopXardIds,
    topXardIds,
    checkinXardIds,
    listXardIds,
    twinTipXardIds,
    newTipXardIds,
    checkUser,
    loadUser,
    userStatesFor
  }
})
